export const AGENT_RUNNER_AGENT_IDS = [
  "concierge",
  "architect",
  "product-manager",
  "production-support",
  "integration-support",
  "developer-guide",
  "devops",
  "architect-intake",
] as const;

export type AgentRunnerAgentId = (typeof AGENT_RUNNER_AGENT_IDS)[number];

export const AGENT_RUNNER_AGENT_LABELS: Record<AgentRunnerAgentId, string> = {
  concierge: "Concierge",
  architect: "Architect",
  "product-manager": "Product manager",
  "production-support": "Production support",
  "integration-support": "Integration support",
  "developer-guide": "Developer guide",
  devops: "DevOps",
  "architect-intake": "Intake Assistant",
};

/**
 * YAML `agent_name` (filename stem) used in runner paths `/{agentName}/session`.
 * CMS / UI workspace ids are not registered runner names.
 */
export const RUNNER_AGENT_NAMES: Record<AgentRunnerAgentId, string> = {
  concierge: "sami_concierge_agent",
  architect: "sami_architect_agent",
  "product-manager": "sami_product_manager_agent",
  "production-support": "sami_production_support_agent",
  "integration-support": "sami_integration_support_agent",
  "developer-guide": "sami_developer_guide_agent",
  devops: "sami_devops_agent",
  "architect-intake": "sami_architect_intake_agent",
};

export const DEFAULT_AGENT_RUNNER_BASE_PATH = "/api/v2/sami/agent";

export function runnerAgentPathSegment(workspaceAgentId: string): string {
  if ((AGENT_RUNNER_AGENT_IDS as readonly string[]).includes(workspaceAgentId)) {
    return RUNNER_AGENT_NAMES[workspaceAgentId as AgentRunnerAgentId];
  }
  return workspaceAgentId;
}

export function stripTrailingSlash(path: string): string {
  return path.replace(/\/+$/, "") || "/";
}
